
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M452.82 458H59.171C26.538 458 0 431.496 0 398.907V159.254c0-32.589 26.538-59.093 59.171-59.093h80.323l7.031-23.687C149.396 63.513 161.259 54 175.214 54h161.573c13.56 0 25.561 9.464 28.737 22.593l.188.807 6.409 22.76h80.709c32.631 0 59.17 26.503 59.17 59.093v239.651C511.99 431.496 485.442 458 452.82 458zM59.171 119.86c-21.757 0-39.447 17.669-39.447 39.394v239.651c0 21.727 17.692 39.395 39.447 39.395H452.82c21.755 0 39.446-17.669 39.446-39.395V159.254c0-21.727-17.693-39.394-39.446-39.394h-95.639L346.385 81.4c-.998-4.472-5.03-7.711-9.606-7.711H175.203c-4.646 0-8.59 3.171-9.606 7.722l-11.399 38.45H59.171zM256.01 398.463c-69.021 0-125.174-56.069-125.174-124.991 0-68.932 56.151-125.001 125.174-125.001 69.004 0 125.146 56.079 125.146 125.001-.002 68.912-56.144 124.991-125.146 124.991zm0-230.305c-58.145 0-105.45 47.234-105.45 105.304s47.308 105.293 105.45 105.293c58.135 0 105.422-47.234 105.422-105.293-.001-58.069-47.298-105.304-105.422-105.304zm184.079-11.74c-10.059 0-18.195 8.145-18.195 18.172 0 10.036 8.136 18.17 18.195 18.17 10.049 0 18.185-8.136 18.185-18.17-.009-10.027-8.147-18.172-18.185-18.172z"}})])
          )
        }
      }
    